"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ConectividadSinLMites() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="223331" id="conectividad-sin-límites" className="bg-background text-foreground relative w-full flex items-center justify-center overflow-hidden">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/avtecsa_telecom_hero.png)] bg-cover bg-center" />
        <div className="absolute inset-0 bg-accent/80 backdrop-blur-[2px]" />
      </div>

      {/* Content */}
      <div ref={ref} className={`relative z-10 max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-12 md:py-16 flex flex-col items-center text-center transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <span className="inline-block px-4 py-2 rounded-md bg-primary/10 text-primary text-[10px] sm:text-xs font-default font-semibold tracking-wider uppercase mb-8 border border-primary/20">
          Soluciones de Telecomunicaciones Avanzadas
        </span>

        <h1 className="font-default text-4xl sm:text-5xl md:text-6xl lg:text-[72px] font-bold text-primary leading-tight mb-6 tracking-tighter">Conectividad Sin Límites para su Empresa - Atendemos toda Centroamérica por más de 25 años.</h1>

        <p className="font-sans text-[16px] text-foreground max-w-2xl mb-10 leading-relaxed">
          Impulsamos su comunicación con integración de MS Teams, agentes de IA y centrales telefónicas de última generación. Optimice su flujo de trabajo con tecnología diseñada para la eficiencia y el crecimiento constante.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="w-full sm:w-auto font-semibold">
            <Link to="#agende-asesoria-form">
              <SafeHydrate><Calendar className="size-4" /></SafeHydrate>
              Agendar Asesoría
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto font-semibold">
            <a href="tel:+50622633278">
              <Phone className="size-4" />
              Llamar Ahora
            </a>
          </Button>

          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto font-semibold">
            <Link to="https://wa.me/50687176886" newTab>
              <MessageCircle className="size-4" />
              WhatsApp
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}